module.exports = __webpack_public_path__ + "img/pr-26.7420a264.png";